import { API_BASE_URL, apiRequest, type ApiRequestOptions } from '../http.ts';
import type { APIResponse, MessageData } from './types/common.ts';
import type { ManagedAccountsData } from './types/managedAccounts.ts';

export interface ManagedAccountTokenResponse {
  access_token: string;
  token_type: string;
}

/** Manager-owned account listing and account-context switching endpoints. */
export class ManagedAccountsApiService {
  private readonly baseUrl: string;

  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl;
  }

  private request<T>(endpoint: string, options: ApiRequestOptions = {}): Promise<T> {
    return apiRequest<T>(endpoint, options);
  }

  getManagedAccounts(): Promise<APIResponse<ManagedAccountsData>> {
    return this.request<APIResponse<ManagedAccountsData>>(`${this.baseUrl}/managers/accounts`);
  }

  addManagedAccount(managedUserId: number): Promise<APIResponse<MessageData>> {
    return this.request<APIResponse<MessageData>>(`${this.baseUrl}/managers/accounts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ managed_user_id: managedUserId }),
    });
  }

  removeManagedAccount(managedUserId: number): Promise<APIResponse<MessageData>> {
    return this.request<APIResponse<MessageData>>(
      `${this.baseUrl}/managers/accounts/${managedUserId}`,
      { method: 'DELETE' },
    );
  }

  switchToManagedAccount(managedUserId: number): Promise<ManagedAccountTokenResponse> {
    return this.request<ManagedAccountTokenResponse>(`${this.baseUrl}/managers/switch/${managedUserId}`, { method: 'POST' });
  }

  switchBackToOwnAccount(): Promise<ManagedAccountTokenResponse> {
    return this.request<ManagedAccountTokenResponse>(`${this.baseUrl}/managers/switch-back`, { method: 'POST' });
  }
}
